import { Trigger } from '@kobalte/core/dialog';
import { IconPlayButton } from '@troon/icons/play-button';
import { Dialog, DialogContent } from '../overlays';
import { Picture } from '../components';

type Props = {
	code: string;
	poster?: string;
};

export function YoutubeVideo(props: Props) {
	return (
		<div class="relative aspect-video w-full overflow-hidden rounded-lg">
			<Dialog key="video">
				<Trigger
					as="button"
					class="group size-full outline-none focus-visible:ring-2 focus-visible:ring-brand-100 focus-visible:ring-offset-2"
				>
					<Picture
						src={props.poster ?? `https://img.youtube.com/vi/${props.code}/hqdefault.jpg`}
						class="absolute inset-0 z-0 aspect-video size-full bg-center object-cover group-hover:scale-105 motion-safe:transition-transform motion-safe:duration-100"
						width={768}
						height={480}
						sizes="(min-width: 1024px) 60vw, (min-width: 768px) 75vw, 95vw"
						loading="lazy"
					/>
					<span class="absolute inset-0 flex items-center justify-center text-white outline-none group-hover:text-brand-100/80 focus-visible:ring focus-visible:ring-brand-100 focus-visible:ring-offset-2 active:scale-95 motion-safe:transition-all motion-safe:duration-200">
						<IconPlayButton class="size-16" />
						<span class="sr-only">Play video</span>
					</span>
				</Trigger>
				<DialogContent height="full" width="fit" noPadding>
					<div class="aspect-video w-svw p-4">
						<iframe
							class="aspect-video size-full rounded-xl"
							src={`https://www.youtube-nocookie.com/embed/${props.code}?autoplay=1&rel=0`}
							title="YouTube video player"
							allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
							allowfullscreen
						/>
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
}
